'use client';

import { useState } from 'react';
import { useWorkflowStore } from '../../../stores/workflowStore';
import { FileUploadWidget } from './FileUploadWidget';

interface LoadCSVConfigProps {
  nodeId: string;
  config: { fileName?: string; rowCount?: number; separator?: string; encoding?: string; hasHeader?: boolean };
}

export function LoadCSVConfig({ nodeId, config }: LoadCSVConfigProps) {
  const { updateNodeConfig } = useWorkflowStore();
  const [separator, setSeparator] = useState(config.separator || ',');
  const [encoding, setEncoding]   = useState(config.encoding  || 'utf-8');
  const [hasHeader, setHasHeader] = useState(config.hasHeader !== false);

  const save = (updates: Partial<typeof config>) => {
    updateNodeConfig(nodeId, {
      type: 'load_csv',
      params: { fileName: config.fileName, rowCount: config.rowCount, separator, encoding, hasHeader, ...updates },
    });
  };

  return (
    <div className="space-y-5">
      {/* File upload area */}
      <FileUploadWidget nodeId={nodeId} accept="csv" />

      {/* Parsing options */}
      <div className="space-y-3">
        <p className="text-xs font-medium text-zinc-500">解析选项</p>

        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-1.5">
            <label className="text-[10px] font-medium text-zinc-400">分隔符</label>
            <select value={separator} onChange={(e) => { setSeparator(e.target.value); save({ separator: e.target.value }); }}
              className="w-full text-sm bg-white border border-zinc-200 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500"
            >
              <option value=",">逗号 (,)</option>
              <option value="\t">制表符 (Tab)</option>
              <option value=";">分号 (;)</option>
              <option value="|">竖线 (|)</option>
            </select>
          </div>
          <div className="space-y-1.5">
            <label className="text-[10px] font-medium text-zinc-400">编码格式</label>
            <select value={encoding} onChange={(e) => { setEncoding(e.target.value); save({ encoding: e.target.value }); }}
              className="w-full text-sm bg-white border border-zinc-200 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500"
            >
              <option value="utf-8">UTF-8</option>
              <option value="gbk">GBK</option>
              <option value="gb2312">GB2312</option>
            </select>
          </div>
        </div>

        <label className="flex items-center gap-2.5 cursor-pointer">
          <input type="checkbox" checked={hasHeader}
            onChange={(e) => { setHasHeader(e.target.checked); save({ hasHeader: e.target.checked }); }}
            className="w-4 h-4 text-emerald-600 rounded border-zinc-300 focus:ring-emerald-500"
          />
          <span className="text-sm text-zinc-700">首行为列标题</span>
        </label>
      </div>
    </div>
  );
}
